<template>
    <Teleport to="body">
        <Transition name="fade">
            <div class="fixed z-50 inset-0 bg-overlay flex items-center justify-center"
                 @click.self="$emit(closeAction)" @keyup.escape="$emit(closeAction)" v-if="show" v-bind="$attrs">
                <AppContainer class="max-w-screen-md">
                    <slot></slot>
                </AppContainer>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";

export default {
    emits: ['close', 'bounce'],
    props: {
        show: Boolean,
        close: Boolean
    },
    components: {AppContainer},
    computed: {
         closeAction() {
            return this.close ? 'close' : 'bounce';
        }
    }
};
</script>

<style scoped>

</style>
